// Actions
export const setOpportunities = ({ commit }, payload) => {
  commit('SET_OPPORTUNITIES', payload)
}
export const addOpportunities = ({ commit }, payload) => {
  commit('ADD_OPPORTUNITIES', payload)
}
export const setOpportunitiesLoading = ({ commit }, payload) => {
  commit('SET_OPPORTUNITIES_LOADING', payload)
}

export const setProdutos = ({ commit }, payload) => {
  commit('SET_PRODUTOS', payload)
}
export const addProdutos = ({ commit }, payload) => {
  commit('ADD_PRODUTOS', payload)
}
export const setProdutosLoading = ({ commit }, payload) => {
  commit('SET_PRODUTOS_LOADING', payload)
}

export const setClients = ({ commit }, payload) => {
  commit('SET_CLIENTS', payload)
}
export const addClients = ({ commit }, payload) => {
  commit('ADD_CLIENTS', payload)
}
export const setClientsLoading = ({ commit }, payload) => {
  commit('SET_CLIENTS_LOADING', payload)
}
